import { Textarea } from '@optimus-web/core';
import { connectCheckoutField } from '../../utils/connectCheckoutField';

export const CheckoutTextarea = connectCheckoutField()(Textarea);
